// Central catalog for EELLEVEN MINING.

export const PRODUCTS = [
  // ============= METALS & MINERAL PRODUCTS =============
  {
    slug: "copper-cathodes",
    name: "Copper Cathodes",
    tagline: "99.99% pure. LME Grade A.",
    category: "Metals & Minerals",
    image:
      "https://images.unsplash.com/photo-1753771145085-d71e89c23092",
    summary:
      "LME-registered specification copper cathodes (99.99% Cu) suitable for wire rod, electrical and industrial applications.",
    body: [
      "Electrolytically refined copper cathodes meeting LME Grade A specification (BS EN 1978:1998 — Cu-CATH-1). Used as primary feedstock for wire rod, brass, bronze and high-conductivity applications.",
      "Each consignment is supplied with manufacturer's certificate of analysis (COA), packing list, certificate of origin and bill of lading.",
    ],
    pillars: [
      "LME Grade A specification",
      "Bundled and strapped for sea freight",
      "Full chain-of-custody documentation",
    ],
    specs: [
      ["Purity", "99.99% Cu (min.)"],
      ["Standard", "LME Grade A / BS EN 1978:1998"],
      ["Thickness", "9 – 12 mm"],
      ["Sheet Size", "914 × 914 mm (approx.)"],
      ["Weight / Cathode", "~125 kg"],
      ["Packing", "Steel-strapped bundles, ~2 MT"],
      ["Min. Order", "25 MT"],
      ["Incoterms", "FOB / CFR"],
      ["Payment", "TT / Escrow"],
    ],
  },
  {
    slug: "copper-wire-scrap",
    name: "Copper Wire Scrap",
    tagline: "Grade A · 99.9% bare-bright.",
    category: "Metals & Minerals",
    image:
      "https://images.unsplash.com/photo-1717667745852-a5bd6876c1de",
    summary:
      "Grade A copper wire scrap (99.9%) — clean, uncoated, untinned, unalloyed copper wire, free of burnt material and brittle.",
    body: [
      "Grade A copper wire scrap is the highest-grade copper scrap classification (ISRI Bare-Bright). It is clean, uncoated, untinned, unalloyed copper wire and cable, free of burnt material and brittle wire.",
      "Aggregated from licensed Zambian sources, weighed on certified weighbridge and ready for FOB load. Pre-shipment inspection (SGS / BV) on buyer's account.",
    ],
    pillars: [
      "ISRI Bare-Bright grade",
      "Weighbridge-certified loading",
      "SGS / BV inspection on request",
    ],
    specs: [
      ["Grade", "ISRI Bare-Bright"],
      ["Purity", "99.9% Cu (min.)"],
      ["Form", "Bare-bright wire, granules"],
      ["Moisture", "≤ 0.5%"],
      ["Packing", "Loose bulk / 1 MT jumbo bags"],
      ["Min. Order", "25 MT"],
      ["Available", "100 MT+ monthly"],
      ["Incoterms", "FOB / CFR"],
      ["Payment", "TT / Escrow"],
    ],
  },
  {
    slug: "copper-concentrate",
    name: "Copper Concentrate",
    tagline: "Cu 20% – 40%. Smelter-ready.",
    category: "Metals & Minerals",
    image:
      "https://images.unsplash.com/photo-1753771145110-b3ddcd1b0ae2",
    summary:
      "Beneficiated copper concentrate from Zambia's Copperbelt — typically 20–40% Cu, low impurities, moisture-controlled. Smelter-ready powder for global refiners.",
    body: [
      "Copper concentrate is one of the most critical intermediates in the copper production chain. Produced through ore beneficiation, it carries 20–40% Cu and is essential feedstock for smelters and refiners worldwide.",
      "Our concentrate is sourced from Zambia's prolific Copperbelt. Rigorous processing and QC deliver consistent Cu content, low impurities and tight moisture control — directly improving smelting yield.",
    ],
    pillars: [
      "Ore selection from high-yield deposits",
      "Crushing, milling and flotation processing",
      "Export packaging & logistics worldwide",
    ],
    specs: [
      ["Cu Content", "20% – 40%"],
      ["Form", "Concentrate powder"],
      ["Impurities", "Low (As, Pb within smelter spec)"],
      ["Moisture", "≤ 9%"],
      ["Packing", "1 MT jumbo bags / bulk"],
      ["Origin", "Zambia (Copperbelt)"],
      ["Min. Order", "100 MT"],
      ["Loading Ports", "Dar es Salaam / Walvis Bay"],
      ["Incoterms", "FOB / CFR"],
      ["Payment", "TT / Escrow"],
    ],
  },
  {
    slug: "copper-ore",
    name: "Copper Ore",
    tagline: "Run-of-mine. 2% – 5% Cu.",
    category: "Metals & Minerals",
    image:
      "https://images.unsplash.com/photo-1753771145101-27bf20e71b6f",
    summary:
      "Run-of-mine copper ore (sulphide & oxide) sourced from licensed Zambian Copperbelt deposits. Suitable for further beneficiation and smelting feedstock.",
    body: [
      "Raw copper ore (both sulphide and oxide types) extracted from licensed Zambian operations. Supplied as run-of-mine or screened to buyer specification.",
      "Assay reports issued at point of loading. Sampling and analysis through SGS or CCIC at buyer's option prior to dispatch.",
    ],
    pillars: [
      "Sulphide & oxide ore available",
      "Run-of-mine or screened",
      "Independent assay on load",
    ],
    specs: [
      ["Cu Content", "2% – 5% (typical)"],
      ["Ore Type", "Sulphide / Oxide"],
      ["Form", "Lump / Screened"],
      ["Moisture", "≤ 8%"],
      ["Origin", "Zambia (Copperbelt)"],
      ["Min. Order", "5,000 MT"],
      ["Incoterms", "FOB"],
      ["Payment", "TT / Escrow"],
    ],
  },
  {
    slug: "cobalt-ore",
    name: "Cobalt Ore",
    tagline: "Co 1% – 5% raw ore.",
    category: "Metals & Minerals",
    image:
      "https://images.unsplash.com/photo-1632734825563-e180215f0c90",
    summary:
      "Raw cobalt ore from regional Central African deposits — Co 1–5%. Essential feedstock for cobalt refineries, EV battery and superalloy industries.",
    body: [
      "Cobalt ore sourced from regional Central African deposits (Zambia / DRC corridor). Cobalt is a critical mineral for lithium-ion batteries, superalloys and high-temperature industrial applications.",
      "Ore is sampled and assayed at load point; buyers may appoint independent inspection (SGS / BV / CCIC) for verification before dispatch.",
    ],
    pillars: [
      "Battery-grade upstream feedstock",
      "Independent assay supported",
      "Licensed export channel",
    ],
    specs: [
      ["Co Content", "1% – 5%"],
      ["Form", "Run-of-mine ore"],
      ["Moisture", "≤ 10%"],
      ["Origin", "Central African region"],
      ["Min. Order", "1,000 MT"],
      ["Incoterms", "FOB / CFR"],
      ["Payment", "TT / Escrow"],
    ],
  },
  {
    slug: "manganese-ore",
    name: "Manganese Ore",
    tagline: "Mn 38% – 46% lump & fines.",
    category: "Metals & Minerals",
    image:
      "https://images.pexels.com/photos/11666903/pexels-photo-11666903.jpeg",
    summary:
      "Manganese ore (Mn 38–46%) supplied as lump or fines for ferro-alloy and steel manufacture.",
    body: [
      "Manganese ore from regional Southern African deposits — lump (10–60 mm) and fines, used in the production of ferro-manganese, silico-manganese and steel.",
      "Cargoes blended and sized to buyer's specification; loading from Walvis Bay / Beira corridors.",
    ],
    pillars: [
      "Mn 38–46% range",
      "Lump and fines sizing",
      "Blended to buyer specification",
    ],
    specs: [
      ["Mn Content", "38% – 46%"],
      ["Form", "Lump (10–60 mm) / Fines"],
      ["Fe", "≤ 8%"],
      ["P", "≤ 0.15%"],
      ["Moisture", "≤ 6%"],
      ["Min. Order", "10,000 MT"],
      ["Incoterms", "FOB / CFR"],
      ["Payment", "TT / Escrow"],
    ],
  },

  {
    slug: "coal",
    name: "Coal",
    tagline: "Thermal & coking. 5,500–6,500 kcal/kg.",
    category: "Metals & Minerals",
    image:
      "https://images.unsplash.com/photo-1676134711846-1f228a647cba",
    summary:
      "Thermal and coking coal from regional Southern African deposits — calorific value 5,500–6,500 kcal/kg, low sulphur, sized to buyer specification.",
    body: [
      "Thermal coal for power generation and coking coal for steel production, sourced from regional Southern African mines and delivered to international buyers.",
      "Cargoes are sampled and analysed at load port (ash, moisture, sulphur, calorific value). Independent inspection (SGS / CCIC) supported at buyer's option.",
    ],
    pillars: [
      "Thermal & coking grades",
      "Low sulphur, controlled ash",
      "Sized to buyer specification",
    ],
    specs: [
      ["Calorific Value", "5,500 – 6,500 kcal/kg (NAR)"],
      ["Ash Content", "≤ 15%"],
      ["Total Moisture", "≤ 12%"],
      ["Sulphur", "≤ 1%"],
      ["Volatile Matter", "22% – 32%"],
      ["Sizing", "0–50 mm (to spec)"],
      ["Min. Order", "10,000 MT"],
      ["Incoterms", "FOB / CFR"],
      ["Payment", "TT / Escrow"],
    ],
  },
];

export const PRODUCT_CATEGORIES = [
  {
    key: "Metals & Minerals",
    label: "Metals & Mineral Products",
    blurb:
      "Copper, cobalt, manganese and coal — sourced from Zambia and the wider Central African region.",
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);

export const COMPANY = {
  name: "EELLEVEN MINING",
  tagline: "Strength. Strategy. Sustainable Future.",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_eelleven-mining/artifacts/4xetwy15_145281CF-4B62-454F-BEB3-B7C4DDB3E94C.png",
  email: "eellevenmining@gmail.com",
  whatsappPrimary: "+353857301049",
  whatsappPrimaryDigits: "353857301049",
  phoneZambia: "+260771110737",
  phoneZambiaDigits: "260771110737",
  phoneZambia2: "+260969842663",
  phoneZambia2Digits: "260969842663",
  address: "Plot 316, Industrial Area, Kabwe",
  country: "Zambia",
  location: "Plot 316, Industrial Area, Kabwe, Zambia",
  sites: [
    {
      name: "Kabwe — Headquarters",
      label: "HQ & Export Yard",
      address: "Plot 316, Industrial Area, Kabwe",
    },
  ],
};

// Leadership team
export const TEAM = [
  {
    name: "Lubomba Hamahuwa",
    role: "Managing Director & Co-Founder",
    photo:
      "https://customer-assets.emergentagent.com/job_eelleven-mining/artifacts/ijhcoil1_IMG_5724.jpeg",
    bio: "Provides the strategic leadership and executive direction of EELLEVEN MINING, overseeing the company's mining operations, international trade, corporate finance, and long-term growth strategy. Leads the executive team and drives the development of high-value commercial partnerships, investment opportunities, and cross-border business initiatives. As the company's principal representative, he engages with governments, regulators, global buyers, commodity traders, refiners, financial institutions, and capital partners across Africa, Europe, the Middle East, and Asia, positioning EELLEVEN MINING as a trusted and internationally connected mining enterprise.",
    focus: ["Group Strategy", "Operations", "Investor Relations"],
    email: "eellevenmining@gmail.com",
    whatsapp: "+353857301049",
    whatsappDigits: "353857301049",
    phone: "+260771110737",
    phoneDigits: "260771110737",
  },
  {
    name: "Dean Cronin",
    role: "Managing Director & Co-Founder",
    photo:
      "https://customer-assets.emergentagent.com/job_eelleven-mining/artifacts/ncfp3hux_IMG_5726.jpeg",
    bio: "Co-Founder and Managing Director of EELLEVEN MINING, leading commercial strategy and international expansion from the company's European headquarters. He oversees global business development, trade and strategic partnerships — connecting EELLEVEN's Zambian operations with buyers, refiners and trading houses across Europe and beyond.",
    focus: ["Commercial", "International Partnerships", "Trade Desk"],
    email: "eellevenmining@gmail.com",
    whatsapp: "+353857301049",
    whatsappDigits: "353857301049",
    phone: "+260771110737",
    phoneDigits: "260771110737",
  },
];
